import { c as _c } from "react/compiler-runtime";
import React, { useState, useCallback } from 'react';
import BrowserOnly from 'components/consumer/BrowserOnly';
import UpdateZipcodeSidebar from 'components/consumer/UpdateZipcodeSidebar';
import useZipCode from 'global-state/zipCode/useZipCode';
import useIsZipCodeFromUserServiceable from 'global-state/isZipCodeFromUserServiceable/useIsZipCodeFromUserServiceable';
import useZipCodeFromUser from 'global-state/zipCodeFromUser/useZipCodeFromUser';
import useUserLocation from 'global-state/userLocation/useUserLocation';
import useUserLocationLoading from 'global-state/userLocationLoading/useUserLocationLoading';
import QuickshipZipCodeEditLocationUI from './QuickshipZipCodeEditLocationUI';
const QuickshipZipCodeEditLocation = () => {
  const $ = _c(12);
  const zipCode = useZipCode();
  const zipCodeFromUser = useZipCodeFromUser();
  const userLocation = useUserLocation();
  const isLocationLoading = useUserLocationLoading();
  const [isUpdateZipcodeOpen, setIsUpdateZipcodeOpen] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setIsUpdateZipcodeOpen(_temp);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const toggleUpdateZipCodeSidebar = t0;
  const isZipCodeFromUserServiceable = useIsZipCodeFromUserServiceable();
  const {
    country: locationCountry
  } = userLocation;
  const isUserInUS = locationCountry === "United States";
  let t1;
  if ($[1] !== isUpdateZipcodeOpen) {
    t1 = <BrowserOnly><UpdateZipcodeSidebar isZipcodeFormOpen={isUpdateZipcodeOpen} onClose={toggleUpdateZipCodeSidebar} /></BrowserOnly>;
    $[1] = isUpdateZipcodeOpen;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== isLocationLoading || $[4] !== isUserInUS || $[5] !== isZipCodeFromUserServiceable || $[6] !== zipCode || $[7] !== zipCodeFromUser) {
    t2 = <QuickshipZipCodeEditLocationUI isLoading={isLocationLoading} isUserInUS={isUserInUS} isZipCodeFromUserServiceable={isZipCodeFromUserServiceable} toggleUpdateZipCodeSidebar={toggleUpdateZipCodeSidebar} zipCode={zipCode} zipCodeFromUser={zipCodeFromUser} />;
    $[3] = isLocationLoading;
    $[4] = isUserInUS;
    $[5] = isZipCodeFromUserServiceable;
    $[6] = zipCode;
    $[7] = zipCodeFromUser;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t1 || $[10] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};
export default React.memo(QuickshipZipCodeEditLocation);
function _temp(prevIsUpdateZipcodeOpen) {
  return !prevIsUpdateZipcodeOpen;
}